import {ProfissionalOrcamentoController} from "./profissionalOrcamentoController";
declare var window: any
import { ControllerBase } from 'controllerBase';
const ko = require('knockout')
declare var AsideDireita: any
import { Paginator } from "paginator";
import {EditarIndicadorController} from "./editarIndicadorController";
import {VendedorOrcamentoController} from "./vendedorOrcamentoController";
import {CadastroIndicadorController} from "./cadastroIndicadorController";
export const PesquisarIndicadorOrcamentoController = ControllerBase.extend({
    name: "PesquisarIndicadorOrcamentoController",
    framework: "knockout",
    ajax: function () {
        return {
            url: "/Orcamento/_Comissoes",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },
    events: {
        'click #novo-indicador': "novoIndicador"
    },
    atacharEventos: function () {
        $("#breadcrumb-cancelar").click($.proxy(this.pesquisarAoVoltar, this));
        $("input").on('focus', function () { $(this).select(); });
    },
    pesquisarAoVoltar: function () {
        AsideDireita.ocultarMenuCliente(); // manut-199
        if (!this.orcamento.get("Indicador")) {
            this.getActionButton({ text: "Editar" }).hide();
        }
    },
    newModel: function () {
        return {
            Nome: null,
            CpfCnpj: null,
            Todos: false,
            Indicadores: [],
            Indicador: null
        };
    },
    antesRenderizacaoCompleta: function () {
        this.botaoLimpar = this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(function () {
                AsideDireita.ocultarMenuCliente(); // manut-199
                this.limpar();
            }, this)
        }, true);

        this.botaoEditar = this.addActionButton({
            text: "Editar",
            'class': "icone-editar separador",
            click: $.proxy(function () {
                this.editarIndicador();
            }, this)
        }, true);

        this.atacharEventos();

    },

    antesBinding: function () {
        var self = this;
        this.appendToModel({ name: "possuiSelecionado", value: false });

        if (this.orcamento.get("Indicador")) {
            var indicador = $.extend({}, this.orcamento.get("Indicador"), true);

            if (indicador.Codigo > 7) { //FNX-5597
                global.ajax({
                    url: "/Orcamento/ObterValoresIndicador",
                    type: "post",
                    data: {
                        identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                        codigoIndicador: indicador.Codigo
                    },
                    success: function (data) {

                        if (!data) {
                            return;
                        }

                        var indicador = $.extend({}, self.orcamento.get("Indicador"), true);

                        indicador.BaseCalculoComissao = data.BaseCalculoComissao;
                        indicador.ValorComissao = data.ValorComissao;

                        self.model.Indicador(ko.mapping.fromJS(indicador));
                    }
                });
            }

            this.model.Indicador(ko.mapping.fromJS(indicador));
        }

    },

    renderizado: function () {
        if (!this.tabInicial) {
            return;
        }

        switch (this.tabInicial) {
            case "profissionais":
                $("a[href=#tab-profissionais]").tab("show");
                this.renderizarTabProfissionais();
                break;
        }

    },

    aposBinding: function () {

        if (!this.orcamento.get("Indicador")) {
            this.getActionButton({ text: "Editar" }).hide();
        }

        //if (this.orcamento.get('Indicador')) {
        //    this.getActionButton({ text: 'Limpar' }).show();
        //} else {
        //    this.getActionButton({ text: 'Limpar' }).hide();
        //}

        $("a[data-toggle=\"tab\"]", this.region.$el).on("shown.bs.tab", $.proxy(this.tabSelecionada, this));

        if ($("a[data-toggle=\"tab\"]", this.region.$el).length > 0) {
            var tabSelecionada = $("a[data-toggle=\"tab\"]", this.region.$el)[0].hash;
            $("a[href=" + tabSelecionada + "]", this.region.$el).trigger("click");
        }
        /*
        global.applyConditionalMask({
            triggerElement: "input[name=\"CpfCnpjIndicador\"]",
            triggerEvent: "keydown",
            initialMask: "cpf",
            options: {
                removeMaskOnSubmit: true
            },
            masks: [
                {
                    name: "cpf",
                    mask: "999.999.999-99[9][9][9]",
                    condition: function (e) {
                        return $("input[name=\"CpfCnpjIndicador\"]").inputmask("unmaskedvalue").length < 11;
                    }
                },
                {
                    name: "cnpj",
                    mask: "99.999.999/9999-99",
                    condition: function (e) {
                        return $("input[name=\"CpfCnpjIndicador\"]").inputmask("unmaskedvalue").length >= 11;
                    }
                }
            ]
        });
        */
        global.applyConditionalMask({
            triggerElement: 'input[name="CpfCnpjIndicador"]',
            triggerEvent: "keydown",
            initialMask: "cpf",
            options: {
                removeMaskOnSubmit: true,
                casing: "upper"
            },
            masks: [
                {
                    name: "cpf",
                    mask: "999.999.999-99[9][9][9]",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    },
                    condition: function (e) {
                        if (e.which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }

                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    }
                },
                {
                    name: "cnpj",
                    mask: "AA.AAA.AAA/AAAA-99",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    },
                    condition: function (e) {
                        if (e.which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }

                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    }
                }
            ]
        });

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
        $('#NomeIndicador').focus();
    },

    pesquisar: function (model, e, page) {

        var self = this;

        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: page ? page : 1,
            IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
            Nome: $("input#NomeIndicador").val(),
            CpfCnpj: $("input#CpfCnpjIndicador").val(),
            Todos: this.model.Todos()
        };


        global.ajax({
            url: "/Orcamento/ListarIndicadores",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {

                if (!data) {
                    return;
                }

                self.model.Indicadores(data.Entities);

                this.paginador = new Paginator({
                    container: "#page-indicador",
                    data: data,
                    pageClickCallback: $.proxy(self.paginar, self)
                });

            }
        });

    },

    paginar: function (e) {
        this.pesquisar(this.model, null, e.page);
    },

    selecionar: function (model) {

        var self = this;


        global.ajax({
            url: "/Orcamento/ObterIndicador",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoIndicador: model.Codigo
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                self.model.Indicador(ko.mapping.fromJS(data));
                self.salvar(data);
            }
        });

    },

    editar: function (model) {

        this.editarIndicadorController = this.showView({
            region: {
                name: "editarIndicadorOrcamentoControllerRegion",
                selector: "#editar-indicador-region"
            },
            controller: {
                type: EditarIndicadorController,
                args: {
                    orcamento: this.orcamento,
                    codigoIndicador: model.Codigo,
                    limparIndicadorCallback: $.proxy(this.limparIndicador, this),
                    readOnly: this.readOnly
                }
            }
        });

    },

    limparIndicador: function () {
        this.show();
    },

    salvar: function (model) {


        var self = this;

        var indicador = this.toJS(this.model.Indicador());


        global.ajax({
            url: "/Orcamento/DefinirIndicador",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                indicador: indicador
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                if (!data.HasErrors) {
                    global.showSuccessMessage("Indicador definido com sucesso.");

                    self.orcamento.set("Indicador", data);
                    self.model.Indicador(ko.mapping.fromJS(data));
                    self.getActionButton({ text: "Limpar" }).show();

                    global.ajax({
                        url: "/Orcamento/PermitirAlterarIndicador",
                        type: "get",
                        contentType: "application/json",
                        success: function (permitir) {
                            if (!permitir || permitir.HasErrors) {
                                return;
                            }

                            if (permitir === "True") {
                                self.getActionButton({ text: "Editar" }).show();
                            } else {
                                self.getActionButton({ text: "Editar" }).hide();
                            }
                        }
                    });
                }

            }
        });

    },

    formConfig: {
        selector: "#form-pesquisar-indicadores",
        submit: {
            selector: "#btnPesquisarIndicadores",
            loadingText: "Aguarde...",
            callback: "pesquisar",
            type: "model",
            modelType: "knockout"
        },
    },

    limpar: function () {

        var self = this;

        if (this.model.Indicador()) {

            global.ajax({
                url: "/Orcamento/RemoverIndicador",
                type: "post",
                data: {
                    identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
                },
                success: function (data) {

                    if (!data) {
                        return;
                    }

                    self.orcamento.unset("Indicador");
                    self.model.Indicador(undefined);
                    self.model.Indicadores(undefined);
                    self.getActionButton({ text: "Editar" }).hide();


                }
            });
        };
        global.clearFormFields({ element: this.form });
        this.model.Indicadores(undefined);
        $("input#NomeIndicador").val("");
        $("input#CpfCnpjIndicador").val("");
        this.model.Todos(false);
    },

    tabSelecionada: function (e) {

        var name = $(e.target).attr("aria-controls");

        switch (name) {
            case "tab-indicadores":
                this.antesRenderizacaoCompleta();

                if (!this.orcamento.get("Indicador")) {
                    this.getActionButton({ text: "Editar" }).hide();
                }

                break;
            case "tab-vendedores":

                if (this.vendedorOrcamentoController) {
                    this.vendedorOrcamentoController.antesRenderizacaoCompleta();
                    return;
                }

                this.vendedorOrcamentoController = this.showView({
                    region: {
                        name: "vendedoresOrcamentoRegion",
                        selector: "#tab-vendedores"
                    },
                    controller: {
                        type: VendedorOrcamentoController,
                        args: {
                            orcamento: this.orcamento,
                            readOnly: this.readOnly
                        }
                    }
                });

                break;

            case "tab-profissionais":

                this.renderizarTabProfissionais();

                break;
        }
    },

    editarIndicador: function () {

        this.cadastroIndicadorController = this.showView({
            region: {
                name: "editarDadosIndicadorRegion",
                selector: "#editar-dados-indicador-region"
            },
            controller: {
                type: CadastroIndicadorController,
                args: {
                    codigoIndicador: this.model.Indicador().Codigo(),
                    indicadorCadastradoCallback: $.proxy(this.indicadorCadastrado, this)
                }
            }
        });

    },

    indicadorCadastrado: function (indicador) {

        var self = this;

        if (indicador && this.model.Indicador && this.model.Indicador()) {
            this.model.Indicador().Nome(indicador.Nome);
        }

        this.cadastroIndicadorController.hide();
        this.show();

        setTimeout(function () {
            self.selecionar(indicador);
        }, 500);

    },

    renderizarTabProfissionais: function () {
        if (this.profissionalOrcamentoController) {
            this.profissionalOrcamentoController.antesRenderizacaoCompleta();
            return;
        }

        this.profissionalOrcamentoController = this.showView({
            region: {
                name: "profissionaisOrcamentoRegion",
                selector: "#tab-profissionais"
            },
            controller: {
                type: ProfissionalOrcamentoController,
                args: {
                    orcamento: this.orcamento,
                    readOnly: this.readOnly
                }
            }
        });
    },

    novoIndicador: function (e) {
        if (e) {
            e.preventDefault();
        }

        var cliente = this.orcamento.get("Cliente");
        if (cliente === undefined) {
            global.showErrorMessage("Para usar o Indicador, será necessário informar o cliente antes.");
        } else {
            this.cadastroIndicadorController = this.showView({
                region: {
                    name: "cadastroIndicadorControllerRegion",
                    selector: "#cadastro-indicador-container"
                },
                controller: {
                    type: CadastroIndicadorController,
                    args: {
                        indicadorCadastradoCallback: $.proxy(this.indicadorCadastrado, this),
                        readOnly: this.readOnly
                    }
                }
            });
        }
    }
});

window.PesquisarIndicadorOrcamentoController = PesquisarIndicadorOrcamentoController
